import MessageIcon from '@material-ui/icons/ViewList';

import MessageList from './MerchantGroupList';
import MessageCreate from './MerchantGroupCreate';
import MessageEdit from './MerchantGroupEdit';

export default {
    list: MessageList,
    create: MessageCreate,
    edit: MessageEdit,
    icon: MessageIcon,
};
